"use strict";

var keyCodes = {
    TAB_KEY: 9,
    ENTER_KEY: 13,
    SPACE_KEY: 32,
    ESC_KEY: 27
};

/**
  * @function
  * @description Initialize the focus trap inside an element
  * @param {Element} - Element in which the focus needs to be trapped
  */
function initFocusTrap(element) {
    var $element = $(element);

    if (!$element.length) {
        return;
    }

    $element.focus().on("keydown", function (e) {
        var focusableElems = $element
            .find("a, button, object, :input, iframe, [tabindex]")
            .filter(":not([tabindex=-1]):visible")
            .filter(function () {
                var $this = $(this);
                return !$this.is(":input") || ($this.is(":input") && $this.is(":enabled"));
            });

        var firstFocusableElement = focusableElems.first()[0],
            lastFocusableEl = focusableElems.last()[0],
            isTabPressed = e.key === "Tab" || e.keyCode === 9;

        if (!isTabPressed) {
            return;
        }

        if (e.shiftKey) {
            if (document.activeElement === firstFocusableElement) {
                lastFocusableEl.focus();
                e.preventDefault();
            }
        } else if (document.activeElement === lastFocusableEl) {
            firstFocusableElement.focus();
            e.preventDefault();
        }
    });
}

/**
 * @function
 * @description Destroy the focus trap, inside an element
 * @param {Element} - Element in which the focus needs to be trapped
 */
function destroyFocusTrap(element) {
    var $element = $(element);

    if (!$element.length) {
        return;
    }

    $element.off("keydown");
}

/**
 * @function
 * @description Initialize focus outline, only on keyboard focus on elements
 */
function keyboardFocusOutline() {
    var $document = $(document),
        $html = $("html");

    $document.on("keyup", function () {
        $html.addClass("has-focus");
    });

    $document.on("mousedown", function () {
        $html.removeClass("has-focus");
    });
}

exports.initFocusTrap = initFocusTrap;
exports.destroyFocusTrap = destroyFocusTrap;
exports.keyboardFocusOutline = keyboardFocusOutline;
exports.keyCodes = keyCodes;
